import { useSelector, useDispatch } from 'react-redux';
import { useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { authService, navService } from '../../../Services';

import {ReactComponent as GlobeIcon} from '../../../images/icons/Maps/globe-06.svg';
import {ReactComponent as LogIn} from '../../../images/icons/General/log-in-01.svg';
import {ReactComponent as LogOutIcon} from '../../../images/icons/General/log-out-01.svg';
import {ReactComponent as Loading} from '../../../images/icons/General/loading-01.svg';
import {ReactComponent as Lock} from '../../../images/icons/Security/lock-unlocked-01.svg';

import { setId, setName, setLogoExt, setParentId, setModules, setNav, setExpirations } from '../../../redux/stores/orgSlice';
import { setStatus, setOrgs, setPermissions, setExhibitDiver } from '../../../redux/stores/userSlice';
import { setLocalStatus, setLocalOrgs, setLocalPermissions, setLocalExhibitDiver } from '../../../redux/stores/localUserSlice';

import Modal from '../Modal';

export const ModalOrgs = ({pickOrg, setPickOrg}) => {
    const [statusMessage, setStatusMessage] = useState(false);
    const [regOrgs, setRegOrgs] = useState(null);
    const [type, setType] = useState(0);
    const [loading, setLoading] = useState(null);
    const [error, setError] = useState(false);
    const [omId, setOmId] = useState();
    const remember = useSelector((state) => state.org.remember);
    const orgId = useSelector((state) => state.org.id);
    const orgParentId = useSelector((state) => state.org.parentId);
    const orgName = useSelector((state) => state.org.name);
    const orgs = useSelector((state) => state[remember ? 'localUser' : 'user'].orgs);
    const status = useSelector((state) => state[remember ? 'localUser' : 'user'].status || 0);
    const admin = useSelector((state) => state[remember ? 'localUser' : 'user'].admin || 0);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const customStyles = {
        container: (provided, state) => ({
            ...provided,
            flex: '1',
            height: '42px'
          }),
        control: (provided, state) => ({
          ...provided,
          border: '1px solid #D0D5DD',
          '&:hover': {
            boxShadow: '0 0 1px #5D3FC5'
          }
        })
    }

    const adminSignIn = async (event) => {
        event.preventDefault();

        setLoading(true);

        if (omId) {
            const om = await authService.adminLogin({
                omId: omId.value
            });
    
            if (om) {
                dispatch(setId(om.id));
                dispatch(setName(om.Name));
                dispatch(setParentId(om.parentId));
                dispatch(setLogoExt(om.LogoFileExt));
                dispatch(setModules(om.modules));
                dispatch(setExpirations(om.expirations));
                dispatch(setNav(om.nav ? navService.navJSON(om.nav, om.activityTypes) : navService.defaultNav(om.activityTypes)));
                document.title = om.Name;

                if (remember) {
                    dispatch(setLocalStatus(1));
                    dispatch(setLocalExhibitDiver(om.exhibitDiver));
                    dispatch(setLocalPermissions(om.permissions));
                } else {
                    dispatch(setStatus(1));
                    dispatch(setExhibitDiver(om.exhibitDiver));
                    dispatch(setPermissions(om.permissions));
                }

                setLoading(false);
                setPickOrg(false);
                setStatusMessage(false);
                navigate(location.pathname);
            } else {
                setLoading(false);
                setError(om.error);
            }
        }
        setLoading(false);
    }

    const handleChangeType = async (value) => {
        setLoading(true);

        if (!regOrgs) {
            const data = await authService.orgs(orgParentId || orgId);
            const userOrgs = orgs.map(x => x.id);
            setRegOrgs(data.orgs.filter(org => !userOrgs.includes(org.value)));
        }

        setType(value);
        setOmId(null);
        setLoading(false);
    }

    const signUp = async (event) => {
        event.preventDefault();
        setError(false);

        if (omId) {
            setLoading(true);
            const data = await authService.signUpOM({omId : omId.value});

            if (remember) {
                dispatch(setLocalStatus(data.status));
                dispatch(setLocalOrgs(data.orgs));
            } else {
                dispatch(setStatus(data.status));
                dispatch(setOrgs(data.orgs));
            }

            const org = data.orgs.filter(o => o.id === omId.value)[0];

            dispatch(setId(org.id));
            dispatch(setName(org.Name));
            dispatch(setLogoExt(org.LogoFileExt));
            dispatch(setModules(org.modules));
            dispatch(setExpirations(org.expirations));
            dispatch(setNav(org.nav ? navService.navJSON(org.nav, org.activityTypes) : navService.defaultNav(org.activityTypes)));
            document.title = org.Name;

            setType(0);
            setRegOrgs(null);
            setLoading(false);
        } else 
            setError(true);
    }

    const activate = async () => {
        const data = await authService.activateProfile();

        if (remember) {
            dispatch(setLocalStatus(data.status));
            dispatch(setLocalOrgs(data.orgs));
        } else {
            dispatch(setStatus(data.status));
            dispatch(setOrgs(data.orgs));
        }
    }
    
    const updateStatus = async () => {
        setStatusMessage(false);

        const data = await authService.getStatus();

        if (remember)
            dispatch(setLocalStatus(data.status));
        else 
            dispatch(setStatus(data.status));
        
        if (data.status === 2)
            setStatusMessage(true);
    }

    const changeOrg = (org) => {
        dispatch(setId(org.id));
        dispatch(setName(org.Name));
        dispatch(setLogoExt(org.LogoFileExt));
        dispatch(setParentId(org.parentId));
        dispatch(setModules(org.modules));
        dispatch(setExpirations(org.expirations));
        dispatch(setNav(org.nav ? navService.navJSON(org.nav, org.activityTypes) : navService.defaultNav(org.activityTypes)));
        document.title = org.Name;

        if (remember) {
            dispatch(setLocalPermissions(org.permissions));
            dispatch(setLocalExhibitDiver(org.exhibitDiver));
            dispatch(setLocalStatus(org.ustatus));
        } else {
            dispatch(setPermissions(org.permissions));
            dispatch(setExhibitDiver(org.exhibitDiver));
            dispatch(setStatus(org.ustatus));
        }

        setPickOrg(false);
        setStatusMessage(false);
    }

    const statuses = {
        0: 'Inactive',
        1: 'Active',
        2: 'Waiting for approval'
    };

    return (
        <Modal setClose={pickOrg && status === 1 ? () => setPickOrg(false) : false} icon={<GlobeIcon />} type="orgs">
            <button className="logout-icon" onClick={authService.logout}><LogOutIcon /></button>
            {(admin && type !== 2) ? (loading ? <Loading className="btn-loader admin-icon" alt="loader" /> : <button className="admin-icon" onClick={() => handleChangeType(2)}><Lock /></button>) : ''}
            {type === 2 && <>
                <h2>Admin sign in</h2>
                <form onSubmit={adminSignIn}>
                    <div className="form-control">
                        <label>Organization</label>
                        <Select className={`select ${omId ? '' : 'required'}`} options={regOrgs} onChange={setOmId} styles={customStyles} required value={omId} />
                    </div>
                    <div className="buttons">
                        <button className="primary" disabled={loading}>{loading ? <Loading className="btn-loader" alt="loader" /> : ''}Sign in</button>
                        <button type="button" className="default" onClick={() => {
                            setType(0);
                            setError(false);
                        }}>Cancel</button>
                    </div>
                    {error ? <div className="error">Please select organization</div> : ''}
                </form>
            </>}
            {type === 1 && <>
                <h2>Registration</h2>
                <form onSubmit={signUp}>
                    <div className="form-control">
                        <label>Organization</label>
                        <Select className={`select ${omId ? '' : 'required'}`} options={regOrgs} onChange={setOmId} styles={customStyles} required value={omId} />
                    </div>
                    <div className="buttons">
                        <button className="primary" disabled={loading}>{loading ? <Loading className="btn-loader" alt="loader" /> : ''}Sign up</button>
                        <button type="button" className="default" onClick={() => {
                            setType(0);
                            setError(false);
                        }}>Cancel</button>
                    </div>
                    {error ? <div className="error">Please select organization</div> : ''}
                </form>
            </>} 
            {!type && <>
                <h2>Organizations</h2>
                {orgParentId !== orgId && orgParentId && status === -1 ? 
                    <div className="orgs-alert">
                        <p>We recognize that you have an active user registration on other AAUS dive logging website(s). Would you like to ask the DSO to add your user profile to this {orgName} site?</p>
                        <p className="flex"><button className="primary" onClick={activate}>Yes</button></p>
                    </div> : ''
                }

                {orgParentId !== orgId && status === 2 ? 
                    <div className="orgs-alert green">
                        <p>You successfully made a request to be added to this {orgName} website. Once the DSO reviews and approves your request you will receive an email notification.</p>
                        <p className="flex">{statusMessage ? <span>DSO has not approved your request yet</span> : ''}<button className="primary" onClick={updateStatus}>Update status</button></p>
                    </div> : ''
                }

                {orgParentId !== orgId && status === 0 ? 
                    <div className="orgs-alert red">
                        <p>Your user profile on this {orgName} site is inactive. Would you like to ask the DSO to reactivate it?</p>
                        <p><button className="primary" onClick={activate}>Yes</button></p>
                    </div> : ''
                }
                {orgs ? 
                    <div className="bordered-content">
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Group</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {orgs.map(org => {
                                    return (
                                        <tr key={org.id} className={org.id === orgId ? 'approved' : (org.ustatus === 1 ? '' : 'disabled')}>
                                            <td>{org.Name}</td>
                                            <td><strong className="mobile">Group: </strong>{org.gname}</td>
                                            <td><strong className="mobile">Status: </strong>{org.ustatus > -1 ? statuses[org.ustatus] : 'Not registered'}</td>
                                            <td>{org.id === orgId || org.ustatus !== 1 ? '' : <>
                                                <LogIn onClick={() => changeOrg(org)} className="desktop pointer" />
                                                <span className="pseudo-link mobile" onClick={() => changeOrg(org)}>Sign in</span>
                                            </>}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div> : ''
                }
                <p className="right"><button className="primary" onClick={() => handleChangeType(1)} disabled={loading}>{loading ? <Loading className="btn-loader" alt="loader" /> : ''}Register your user profile in one of the AAUS dive logging websites</button></p>
            </>}
        </Modal>
    )
}

export default ModalOrgs;